import React from 'react';

// Styles
import { Container, CategoryIndicator, CategoryCode } from './styles';

// Types
import { CategoryCodeCellProps } from './types';

export const CategoryCodeCell: React.FC<CategoryCodeCellProps> = ({
  code,
  color,
  className,
}) => {
  const indicatorColor = color || '#cccccc'; // TODO: Replace with theme color

  return (
    <Container className={className}>
      <CategoryIndicator color={indicatorColor} />
      <CategoryCode>{code || '-'}</CategoryCode>
    </Container>
  );
};
